import React from 'react'

const AnnouncementTab = () => {
    return (
        <li>
            <h4> Announcement </h4>

            <div className="user-details-card">
                <div className="user-details-card-avatar">
                    <img src="../assets/images/avatars/avatar-2.jpg" alt="" />
                </div>
                <div className="user-details-card-name">
                    Stella Johnson <span> Instructor <span> 1 year ago </span> </span>
                </div>
            </div>



            <article className="uk-article">

                <p className="lead"> Nam liber tempor cum soluta nobis eleifend option
                        congue </p>

                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis
                aute
                irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
                officia
                        deserunt mollit anim id est laborum.</p>

                <p> Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                nibh
                euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi
                enim ad
                minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl
                ut
                aliquip ex ea commodo consequat. Nam liber tempor cum soluta nobis eleifend
                option congue nihil imperdiet doming id quod mazim placerat facer possim
                assum.
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                nibh
                euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi
                enim ad
                minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl
                ut
                        aliquip ex ea commodo consequat.</p>


            </article>
        </li>

    )
}

export default AnnouncementTab
